import { render, staticRenderFns } from "./PrivilegeItem.vue?vue&type=template&id=56c1839e&scoped=true&"
import script from "./PrivilegeItem.vue?vue&type=script&lang=js&"
export * from "./PrivilegeItem.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeItem.vue?vue&type=style&index=0&id=56c1839e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c1839e",
  null
  
)

export default component.exports